import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {AirlineService} from "app/services";
import {fetchAllAirlines} from "./airline-companies.slice";
import {errorMsg, successMsg} from "../../../../utils/MessageUtils";

interface DeleteAirlineStateParams {
  id: string;
  onSuccess?: Function;
  onError?: Function;
}

export const deleteAirline = (params: DeleteAirlineStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await AirlineService.deleteAirline(params.id);
    if (response.status >= 200 || response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Airline company deleted successfully!' : 'Kompania ajrore u fshi me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllAirlines());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface DeleteAirlineSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteAirlineSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'configurations/airlines',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;